<app-slider></app-slider>

<section id="content">
  <div class="content-wrap pt-0">
    <app-services id="services"></app-services>
    <app-about id="about"></app-about>
  </div>
</section>
